import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { navigationService } from 'src/config/rootService';
import {
    isOnboardingCompleted,
    isOnboardingFirstStepCompleted,
} from 'src/modules/onboarding/selectors/onboardingSelectors';

const onboardingFirstStepRoutes = [
    '/email-preferences',
    '/welcome',
    '/onboarding-privacy',
    '/onboarding-categories',
];
const onboardingSecondStepRoutes = [
    '/onboarding-wellness',
    '/a-few-questions',
    '/onboarding-survey',
];
const oldOnboardingSecondStepRoutes = ['/a-few-questions', '/onboarding-survey'];

export const useOnboardingGuard = () => {
    const flags = useFlags();

    const [guardPassed, setGuardPassed] = useState(false);

    const onboardingFirstStepCompleted = useSelector(isOnboardingFirstStepCompleted);
    const onboardingCompleted = useSelector(isOnboardingCompleted);

    useEffect(() => {
        const currentUrl = window.location.pathname;

        if (onboardingCompleted) {
            navigationService.navigate('/dashboard');

            return;
        }

        let url;

        if (onboardingFirstStepCompleted) {
            // user has already completed first step of the onboarding
            // so we want to take them to the first component of the second step if they are not there yet

            url = flags?.hideTriageSymptoms
                ? !oldOnboardingSecondStepRoutes.includes(currentUrl) &&
                  oldOnboardingSecondStepRoutes[0]
                : !onboardingSecondStepRoutes.includes(currentUrl) && onboardingSecondStepRoutes[0];
        } else {
            // user hasn't completed first step of the onboarding yet
            // so we want to take them to the first component of the first step if they are not there yet

            url = !onboardingFirstStepRoutes.includes(currentUrl) && onboardingFirstStepRoutes[0];
        }

        if (!url) {
            setGuardPassed(true);
        } else {
            navigationService.navigate(url);
        }
    }, [window.location]);

    return guardPassed;
};
